import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { connect } from 'react-redux';
import { profileConstant } from '../../_constants';

// Dynamic theme colors from profileConstant (differs between SVM master and ISM instoremed-master branches)
const themeColor = profileConstant.THEME_PRIMARY || '#3498db';
const headerBgColor = profileConstant.THEME_HEADER_BG || '#f8f9fa';

const modalStyles = {
    dialogPaper: {
        borderRadius: '12px',
        maxHeight: '90vh'
    },
    dialogTitle: {
        backgroundColor: headerBgColor,
        borderBottom: `2px solid ${themeColor}`,
        padding: '1rem 1.5rem',
        textAlign: 'center'
    },
    titleWebsite: {
        fontSize: '0.95rem',
        color: '#7f8c8d',
        marginBottom: '0.25rem'
    },
    titleMain: {
        fontSize: '1.25rem',
        fontWeight: '600',
        color: '#2c3e50',
        margin: 0
    },
    subtitle: {
        fontSize: '0.85rem',
        color: '#95a5a6',
        marginTop: '0.5rem',
        fontWeight: 'normal'
    },
    dialogContent: {
        padding: '1.5rem',
        fontSize: '0.95rem',
        lineHeight: '1.6',
        overflowY: 'auto',
        maxHeight: '60vh'
    },
    dialogActions: {
        backgroundColor: headerBgColor,
        borderTop: '1px solid #e0e0e0',
        padding: '0.75rem 1.5rem',
        justifyContent: 'center'
    },
    closeButton: {
        backgroundColor: themeColor,
        color: '#fff',
        border: 'none',
        borderRadius: '6px',
        padding: '0.5rem 2rem',
        fontSize: '1rem',
        fontWeight: '500',
        cursor: 'pointer',
        minWidth: '120px',
        transition: 'background-color 0.2s ease'
    }
};

class AgreementDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    handleClose = () => {
        // Always close with true (accepted) since checkbox is removed
        this.props.onClose(true);
    };

    renderContent = () => {
        return (
            <div className="content">
                {this.props.content}
            </div>
        );
    }

    render() {
        const { title, open } = this.props;

        return (
            <Dialog
                id="agreement-dialog"
                fullWidth={true}
                maxWidth="md"
                open={open}
                PaperProps={{
                    style: modalStyles.dialogPaper
                }}
            >
                <DialogTitle style={modalStyles.dialogTitle} disableTypography>
                    <div style={modalStyles.titleWebsite}>{profileConstant.DOMAIN_NAME}</div>
                    <h2 style={modalStyles.titleMain}>{title.toUpperCase()}</h2>
                </DialogTitle>
                <DialogContent style={modalStyles.dialogContent}>
                    {this.renderContent()}
                </DialogContent>
                <DialogActions style={modalStyles.dialogActions}>
                    <button
                        style={modalStyles.closeButton}
                        onClick={this.handleClose}
                        onMouseOver={(e) => e.target.style.backgroundColor = '#2980b9'}
                        onMouseOut={(e) => e.target.style.backgroundColor = themeColor}
                    >
                        Close
                    </button>
                </DialogActions>
            </Dialog>
        );
    }
}

AgreementDialog.propTypes = {
    dispatch: PropTypes.func,
    onClose: PropTypes.func,
    open: PropTypes.bool,
    loggedIn: PropTypes.bool,
    title: PropTypes.string,
    content: PropTypes.object
};


function mapStateToProps(state) {
    const { loggedIn } = state.authentication;

    return {
        loggedIn
    };
}

const temp = connect(mapStateToProps)(AgreementDialog);

export { temp as AgreementDialog };
